export enum Field{
    Document = 13,
    Language = 14,
    Education = 17,
    WorkExperience = 26,
    IsWorkExperienceFilled = 35,
    PersonalInfo = 37,
    Photo = 38,
    HardSkill = 39,
    SoftSkill = 40
}